import type { SelectCampaignPopoverProps } from './SelectCampaignPopover';

import { useResetDatepickerByCampaign } from '~/presentation/reports/ui/SelectDate';
import { PopoverStatus } from '~/presentation/reports/ui/SelectPopover';
import { useControlDataChange } from '~/presentation/reports/common';
import { BlockStack, Box, Scrollable } from '@shopify/polaris';
import { CampaignSelector } from './CampaignSelector';

export const CampaignActionList = ({
  defaultValue,
  id,
  isLoading,
  campaignOptions,
  campaignGroupId,
  togglePopoverActive,
}: SelectCampaignPopoverProps) => {
  const { emitControlChange } = useControlDataChange();
  const { resetDatepicker } = useResetDatepickerByCampaign();

  const onChange = (value: string) => {
    emitControlChange({ [id]: value });
    togglePopoverActive(false);
    resetDatepicker([value], campaignGroupId);
  };

  return (
    <>
      <Scrollable vertical scrollbarWidth="thin" horizontal={false} className="max-h-[271px]">
        {campaignOptions?.length && (
          <Box padding="300">
            <BlockStack gap="200">
              {campaignOptions?.map((campaign) => (
                <CampaignSelector
                  key={campaign.value}
                  variants={campaign.variants}
                  id={campaign.value}
                  isSelected={defaultValue === campaign.value}
                  onChange={onChange}
                />
              ))}
            </BlockStack>
          </Box>
        )}
      </Scrollable>
      <PopoverStatus isLoading={isLoading} isShowNoData={!campaignOptions?.length} />
    </>
  );
};
